import { FC } from 'react';
import { Form } from '@remix-run/react';
import { getFormProps, getTextareaProps } from '@conform-to/react';
import { Toaster } from 'react-hot-toast';
import { FieldGroup } from '~/application/components/FieldGroup/FieldGroup';
import { Button } from '~/application/components/Button/Button';
import { Modal } from '~/application/components/Modal/Modal';
import { Textarea } from '~/application/components/Textarea/Textarea';
import { useSponsorRequestModal, Props } from './useSponsorRequestModal';
import styles from './SponsorRequestModal.module.css';

export const SponsorRequessModal: FC<Props> = (props) => {
  const {
    isOpen,
    user,
    onClose,
    data,
    controls,
    form,
    redirectUrl,
    action,
    onClickSend,
    refSubmitButton
  } = useSponsorRequestModal(props);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="スポンサー申請"
        actions={
        <>
            <Button onClick={onClose}>キャンセル</Button>
            <Button color="primary" onClick={onClickSend}>
              送る
            </Button>
          </>}>


        <Form
          method="post"
          action={`/users/${user.id}/sponsor-requests`}
          {...getFormProps(form)}>

          <input type="hidden" name="_action" value={action} />
          <input type="hidden" name="redirectUrl" value={redirectUrl} />
          <div className={styles.body}>
            <p>{user.name}さんにスポンサー申請を送ります。</p>
          </div>
          <div className={styles.fields}>
            <FieldGroup
              label="メッセージ"
              error={data.message.errors && data.message.errors[0]}>

              <Textarea
                {...getTextareaProps(data.message)}
                onChange={(e) => {
                  controls.message.change(e.target.value);
                }} />

            </FieldGroup>
          </div>
          <button hidden={true} ref={refSubmitButton} type={'submit'} />
        </Form>
      </Modal>
      <Toaster />
    </>);

};